import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
// import { TooltipService } from './shared/tooltip.service';
import { MainMapComponent } from './main-map.component';
import { CoreModule } from 'src/app/core/core.module';
import { DragDropModule } from 'src/app/core/drag-drop/drag-drop.module';
import { SharedModule } from '../../shared/shared.module';
import { CommonModule } from '@angular/common';
export const COMPONENTS = [MainMapComponent];

@NgModule({
  declarations: COMPONENTS,
  imports: [TranslateModule, CommonModule, CoreModule, SharedModule, DragDropModule],
  providers: [],
  exports: COMPONENTS,
})
export class MainMapModule {}
